import { useLocalize } from "@/app/api"
import { RootState } from "@/app/store"

export default function Success() {
  const t = useTranslate()
  const nav = useNavigate()
  const localize = useLocalize()
  const redirectUrl = useAppSelector((state: RootState) => state.app.returnUrl)
  const clientDetail = useAppSelector(
    (state: RootState) => state.app.clientDetail,
  )

  const redirect = () => {
    nav("/")
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      window.location.href = redirectUrl
    }, 3000)
    return () => clearTimeout(timeout)
  }, [])

  return (
    <div className="mt-14 mb-10">
      <img className="object-contain mx-auto w-36" src="/login_success.png" />
      <div className="text-2xl font-bold mt-5">{t("success")}</div>
      <div className="mt-2 mb-10">
        {t("success_sub", { name: localize(clientDetail, "name") })}
      </div>
      {/* <div className="mt-10">
            <button className="w-full m-0" onClick={() => redirect()}>{t('finish')}</button>
        </div> */}
    </div>
  )
}
